import React, { useEffect, useState, useRef } from 'react';
import { useAppContext } from '../contexts/AppContext';

import Link from '../components/Link';
import { videoJson } from '../data/Data';

const Commercial = () => {
  return (
    <div className="page-container w-full h-full bg-cover bg-center relative flex justify-center items-center">
      <div className='flex justify-center items-center flex-wrap' style={{width:'60vw'}}>
        <Link to={'/video/energy1'} style={{padding:"2vw"}}>
          <div className='relative flex justify-start flex-col' style={{width:'24vw'}}>
            <img src='./assets/_0002_viewing-costs.png' className='w-full shadow-md shadow-gray-300' />
            <span className='font-sofia uppercase text-black text-left text-title'>Cost & Usage Trends</span>
            <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', bottom:"0.5vw", right:'1vw'}} alt='Commercial' />
          </div>
        </Link>
        <Link to={'/video/energy2'} style={{padding:"2vw"}}>
          <div className='relative flex justify-start flex-col' style={{width:'24vw'}}>
            <img src='./assets/_0003_bill-summary.png' className='w-full shadow-md shadow-gray-300' />
            <span className='font-sofia uppercase text-black text-left text-title'>Bill Summary</span>
            <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', bottom:"0.5vw", right:'1vw'}} alt='Commercial' />
          </div>
        </Link>
        <Link to={'/video/energy3'} style={{padding:"2vw"}}>
          <div className='relative flex justify-start flex-col' style={{width:'24vw'}}>
            <img src='./assets/_0000_ways-to-save.png' className='w-full shadow-md shadow-gray-300' />
            <span className='font-sofia uppercase text-black text-left text-title'>Ways to Save</span>
            <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', bottom:"0.5vw", right:'1vw'}} alt='Commercial' />
          </div>
        </Link>
        <Link to={'/video/energy4'} style={{padding:"2vw"}}>
          <div className='relative flex justify-start flex-col' style={{width:'24vw'}}>
            <img src='./assets/_0001_operations-schedule.png' className='w-full shadow-md shadow-gray-300' />
            <span className='font-sofia uppercase text-black text-left text-title'>Operation Schedule</span>
            <img src='./assets/play-button.svg' className='absolute shadow-md shadow-gray-300 rounded-full heartbeat-image' style={{width:'4vw', bottom:"0.5vw", right:'1vw'}} alt='Commercial' />
          </div>
        </Link>
      </div>
      <Link to={'/energy'}>
        <img src='./assets/exit.png' className='absolute bottom-10 right-10' style={{width:'5vw'}} alt='Back Button' />
      </Link>
    </div>
  )
}

export default Commercial